import { StyleSheet, Platform, Dimensions } from 'react-native';

import { spacing, borderRadius } from '../../styles/theme';

const { width: screenWidth, height: screenHeight } = Dimensions.get('window');

const isSmallScreen = screenWidth < 400;

export const styles = StyleSheet.create({
  responsiveLogo: {
    width: Math.min(screenWidth * 0.9, 760),
    height: Math.min(screenWidth * 0.9, 760) * 0.47,
    alignSelf: 'center',
    marginTop: spacing.xxl,
    marginBottom: spacing.xxl,
    maxHeight: screenHeight * 0.22
  },
  // Responsive VerseCard style
  verseCard: {
    backgroundColor: '#E8B86D',
    borderRadius: isSmallScreen ? 22 : 28,
    paddingVertical: isSmallScreen ? spacing.lg : Math.max(spacing.xxl, screenHeight * 0.04),
    paddingHorizontal: isSmallScreen ? spacing.lg : Math.max(spacing.xxl, screenWidth * 0.07),
    marginBottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'rgba(255, 213, 74, 0.48)',
    overflow: 'hidden',

    ...Platform.select({
      web: {
        boxShadow: '0px 18px 36px 0px rgba(246, 190, 58, 0.18)'
      },
      ios: {
        shadowColor: '#F6BE3A',
        shadowOffset: { width: 0, height: 18 },
        shadowOpacity: 0.18,
        shadowRadius: 32,
      },
      android: {
        elevation: 6,
      }
    })
  },
  verseText: {
    fontSize: isSmallScreen ? 18 : 28,
    fontStyle: 'italic',
    color: '#1D1106',
    textAlign: 'center',
    lineHeight: isSmallScreen ? 28 : 42,
    marginTop: 0,
    marginBottom: 2,
    paddingBottom: 6,
    ...(Platform.OS === 'android' ? {
      includeFontPadding: true,
      textAlignVertical: 'center',
      paddingTop: 2,
    } : {}),
    flexShrink: 1
  },
  verseReference: {
    fontWeight: 'bold',
    fontSize: isSmallScreen ? 12 : 14,
    color: '#FFE8A3',
    textAlign: 'center',
    letterSpacing: 1.4,
    textTransform: 'uppercase',
  },
  // Responsive Get Started button style
  getStartedButton: {
    width: isSmallScreen ? Math.max(screenWidth * 0.9, 180) : Math.max(Math.min(screenWidth * 0.8, 420), 220),
    paddingVertical: isSmallScreen ? spacing.lg : Math.max(spacing.lg, screenHeight * 0.018),
    paddingHorizontal: isSmallScreen ? spacing.md : Math.max(spacing.lg, screenWidth * 0.04),
    borderRadius: isSmallScreen ? 28 : Math.max(borderRadius.xl, screenWidth * 0.07),
    overflow: 'hidden',
    alignSelf: 'center',
    marginTop: 0,

    ...Platform.select({
      web: {
        boxShadow: '0px 4px 24px 0px rgba(79, 70, 229, 0.18)'
      },
      ios: {
        shadowColor: '#4F46E5',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.18,
        shadowRadius: 24,
      },
      android: {
        elevation: 6,
      }
    })
  },
  logo: {
    width: 240,
    height: 240,
    borderRadius: 40,
    alignSelf: 'center'
  },
  container: {
    flex: 1
  },
  gradient: {
    flex: 1,
    position: 'relative'
  },
  star: {
    position: 'absolute',
    backgroundColor: '#FFD54A',
    borderRadius: 50
  },
  sparkle: {
    position: 'absolute',
    fontSize: 12,
    color: '#F6BE3A'
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.xl
  },
  titleContainer: {
    alignItems: 'center',
    marginBottom: spacing.xxl
  },
  mainTitle: {
    fontSize: 48,
    fontWeight: '900',
    color: '#1D1A23',
    textAlign: 'center',
    letterSpacing: 2,
  },
  subTitle: {
    fontSize: 24,
    fontWeight: '600',
    color: '#464555',
    textAlign: 'center',
    letterSpacing: 4,
    marginTop: spacing.sm
  },
  illustrationContainer: {
    alignItems: 'center',
    marginBottom: spacing.xxl,
    position: 'relative'
  },
  crownContainer: {
    marginBottom: -spacing.lg,
    zIndex: 2
  },
  crown: {
    fontSize: 80,
  },
  bookContainer: {
    backgroundColor: '#E0E7FF',
    borderRadius: 20,
    overflow: 'hidden',
    width: 120,
    height: 120,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: {
        boxShadow: '0px 2px 8px rgba(79, 70, 229, 0.12)'
      },
      ios: {
        shadowColor: '#4F46E5',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.12,
        shadowRadius: 8,
      },
      android: {
        elevation: 3,
      }
    })
  },
  book: {
    fontSize: 100,
  },
  description: {
    fontSize: 24,
    fontWeight: '500',
    color: '#777587',
    textAlign: 'center',
    lineHeight: 3,
  },
  pageIndicators: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.xxl
  },
  indicator: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: '#E0E7FF',
    marginHorizontal: spacing.xs
  },
  activeIndicator: {
    backgroundColor: '#4F46E5',
    width: 16,
    height: 16,
    borderRadius: 8
  },
  buttonGradient: {
    paddingVertical: spacing.lg,
    paddingHorizontal: spacing.xl,
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonText: {
    fontSize: 20,
    fontWeight: '700',
    color: '#FFFFFF',
    letterSpacing: 1,
    textTransform: 'uppercase'
  }
});

export default styles;
